import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
const money = (v: any) => Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });
const pct = (v: any) => `${Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;


type Props = { dashboard: any };
class BieDashboardCardsPanel extends React.Component<Props> {
  render() {
    const { dashboard:d = {}} = this.props;
    const items = [
      ['Sales / Ventes', money(d.sales ?? d.ventes ?? d.venthydval)],
      ['Purchases / Achats', money(d.purchases ?? d.achats ?? d.achathydval)],
      ['Salaries', money(d.salaries ?? d.salaires)],
      ['OPEX', money(d.opex)],
      ['Investments', money(d.investments ?? d.investissements)],
      ['Partial Result', money(d.partialresult ?? d.resultatpartiel)],
      ['Margin', pct(d.marginpercent ?? d.margin)],
      ['Capacity Gap', money(d.capacitygap ?? d.gap)],
    ];
    return (
      <Grid container spacing={2}>
        {items.map(([label, value]) => (
          <Grid key={String(label)} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card elevation={1}>
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}
export default BieDashboardCardsPanel;
